import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[templateHost]',
  standalone: false,
})
export class TemplateHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}
